var _ellipse, _ellipse2, _circle, _ellipse3, _ellipse4, _circle2, _circle3, _ellipse5, _ellipse6, _circle4, _circle5, _ellipse7, _ellipse8, _ellipse9, _circle6, _ellipse10, _ellipse11, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMFooterCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 174,
    viewBox: "0 0 185 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.48,
    cy: 114.48,
    rx: 59.48,
    ry: 59.48,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.4786,
    cy: 114.48,
    rx: 52.045,
    ry: 52.045,
    fill: "#FFFFF6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4811,
    cy: 114.48,
    r: 44.61,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.4797,
    cy: 114.48,
    rx: 37.175,
    ry: 37.175,
    fill: "#FFFFF6"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 43.4783,
    cy: 114.48,
    rx: 29.74,
    ry: 29.74,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.4808,
    cy: 114.48,
    r: 22.305,
    fill: "#FFFFF6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.675,
    cy: 117.675,
    r: 40.675,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.677,
    cy: 117.675,
    rx: 35.5906,
    ry: 35.5906,
    fill: "#FFFFF6"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.674,
    cy: 117.675,
    rx: 30.5062,
    ry: 30.5062,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.676,
    cy: 117.675,
    r: 25.4219,
    fill: "#FFFFF6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 143.673,
    cy: 117.675,
    r: 20.3375,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.675,
    cy: 117.675,
    rx: 15.2531,
    ry: 15.2531,
    fill: "#FFFFF6"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.0200005,
    cy: 33.02,
    rx: 33.02,
    ry: 33.02,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.0214081,
    cy: 33.0204,
    rx: 28.8925,
    ry: 28.8925,
    fill: "#FFFFF6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.0189056,
    cy: 33.0199,
    r: 24.765,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.0203133,
    cy: 33.0203,
    rx: 20.6375,
    ry: 20.6375,
    fill: "#FFFFF6"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.021719,
    cy: 33.0198,
    rx: 16.51,
    ry: 16.51,
    fill: "#C9C1AE",
    fillOpacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 0.0192184,
    cy: 33.0202,
    r: 12.3825,
    fill: "#FFFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMFooterCircles);
export default __webpack_public_path__ + "static/media/mFooterCircles.cec156a31a24a1de6afdaecd6f3f182e.svg";
export { ForwardRef as ReactComponent };